export default "__VITE_ASSET__AqA4dxKq__"